// ./games/crash/state/phases/FlewAwayPhase.ts

import type {
  StompMessage,
  StompPhaseUpdate,
} from '@core/Web/types/StompMessage';
import type { IPhase, PhaseContext } from './IPhase';
import { useGamingSessionStore } from '@core/regulatory';
import { trackCrashBust } from '@core/analytics';

export class FlewAwayPhase implements IPhase {
  private context: PhaseContext;
  private details: StompPhaseUpdate['p'];
  private duration: number; // MODIFIED: Added duration property

  constructor(
    context: PhaseContext,
    details: StompPhaseUpdate['p'],
    duration: number // MODIFIED: Accept duration
  ) {
    this.context = context;
    this.details = details;
    this.duration = duration; // MODIFIED: Store duration
  }

  onEnter(): void {
    const finalMultiplier = this.details.bust ?? 1.0;
    console.log(
      `[Phase] ==> Entering FLEW_AWAY phase. Final Multiplier: ${finalMultiplier}x. Duration: ${this.duration}ms`
    );

    this.context.store.setState({
      phase: 'FLEW_AWAY',
      crashedAtX: finalMultiplier,
    });
    trackCrashBust({
      multiplier: finalMultiplier,
      bets: this.context.store.getState().bets,
    });
    // Preserve cashing/cashed slots so a late CASHOUT ACK still resolves
    this.context.store
      .getState()
      .updateBetStatusesForRoundEnd({ keepPendingCashouts: true });

    useGamingSessionStore.getState().settleRoundNetPosition();

    this.context.controller.startFlewAwayAnimation(this.duration);

    // Play crash sound via controller (allows game-specific override)
    if (this.context.controller) {
      this.context.controller.playCrashSound();
    } else if (this.context.audio) {
      this.context.audio.play('crash'); // Or a new 'flew_away' sound
    } else {
      console.warn(
        '[FlewAwayPhase] Audio context not available, skipping crash sound'
      );
    }
  }

  onExit(): void {
    console.log('[Phase] <== Exiting FLEW_AWAY phase.');
  }

  handleMessage(_message: StompMessage): void {
    // No message handling needed here; transitions are driven by controller
  }

  update(_deltaTime: number): void {
    // No timed transitions needed; transitions are driven by controller
  }
}
